<!--
패킹 컴포넌트
------------------------------------
-->
<template>
    <div class="root uk-padding-small">
        <div v-show="! packed">


            <!-- 하우스 정보없음 안내 -->
            <div class="uk-text-center uk-text-danger" v-if="! house">
                하우스정보({{ houseId }}) 조회실패
            </div>

            <!-- 하우스 정보 있음 -->

            <div v-if="house">

                <!-- 상품 -->
                <div class="uk-flex uk-flex-between uk-flex-bottom">
                    <div class="title">
                        1. 상품을 준비하세요
                    </div>
                </div>
                <prods
                    :prods="prods"
                    :csrf-token="csrfToken"
                    :login-user-id="loginUserId"

                    @done:error="cancel"

                    class=""
                ></prods>

                <!-- 총수량 표시 -->
                <div class="total-amount-area mb-30">
                    TOTAL QTY : <strong>{{ totalAmount }}</strong>
                </div>


                <!-- 포장요청 -->
                <div class="pack-request uk-flex mb-30">
                    <div class="title title-left">
                        2. 포장요청을 확인하세요
                    </div>

                    <pack-request
                        class="uk-width-expand"
                        :house="house"
                    ></pack-request>

                </div>

                <div class="uk-flex uk-flex-left">
                    <div class="uk-width-expand sticky-div-min-height">
                        <!-- 무게입력 컴포넌트 -->
                        <div class="uk-flex mb-30">
                            <div class="title title-left">
                                3. 무게({{ defaultUnit }}) / 부피를 입력하세요
                            </div>

                            <app-packages
                                ref="packages"
                                class="uk-width-expand"
                                @total-weight="(val) => totalWeight = val"

                                :default-unit="defaultUnit"

                                :initialize-edit-mode="false"
                                :region-id="house.region_id"
                            >
                                <!-- 무게 미입력 안내화면 -->
                                <div slot="empty-screen" v-if="region.isOsaka()">
                                    <div class="uk-flex uk-flex-between">
                                        <div class="">
                                            CLICK! 무게(부피)를 입력하세요.
                                        </div>
                                        <div class="text-red font-size-1d125rem bg-yellow pr-1rem pl-1rem" v-if="region.isAir()">
                                            <i class="material-icons font-size-1d5rem">{{ region.getTransportMaterialIcon() }}</i>
                                            항공
                                        </div>
                                        <div class="text-blue font-size-1d125rem bg-yellow pr-1rem pl-1rem" v-if="region.isSea()">
                                            <i class="material-icons font-size-1d5rem">{{ region.getTransportMaterialIcon() }}</i>
                                            해상
                                        </div>
                                    </div>

                                </div>
                            </app-packages>
                        </div>

                        <!-- 포장옵션 컴포넌트 -->
                        <div class="title">
                            4. 적용된 포장옵션을 작성하세요
                            <span class="uk-text-danger font-size-0d875rem">(새박스/버블봉투/추가작업비 등 사용 시 반드시 적용해 주세요)</span>
                        </div>
                        <div class="">
                            <app-packing-options
                                class=""
                                ref="options"
                                :region-id="house.region_id"
                                :total-weight="totalWeight"
                            ></app-packing-options>
                        </div>
                    </div>

                    <div class="sticky-div-width">


                    </div>

                </div>


                <div class="sticky-line">
                    <div class="sticky-relative">
                        <div class="sticky-elem uk-flex uk-flex-column uk-flex-between uk-flex-middle">

                            <!-- 하우스 정보 -->
                            <house :house="house" class=""></house>


                            <!-- 총 수량 -->
                            <total-amount v-if="! totalAmountConfirmed" :total-amount="totalAmount" v-model="totalAmountConfirmed" class=""></total-amount>

                            <!-- 무게입력 -->
                            <button
                                class="uk-button uk-button-primary uk-button-large button-input-weight"
                                type="button"
                                @click="$refs.packages.editPackage(0)"
                                v-show="totalAmountConfirmed && ! hasWeight"
                            >


                                <div class="uk-flex uk-flex-center">
                                    <div class="">
                                        <i class="material-icons">edit</i>
                                        무게입력
                                    </div>
                                    <div class="text-red font-size-1d125rem bg-white pr-1rem pl-1rem ml-1rem" v-if="region.isOsaka() && region.isAir()">
                                        <i class="material-icons font-size-1d5rem">{{ region.getTransportMaterialIcon() }}</i>
                                        항공
                                    </div>
                                    <div class="text-blue font-size-1d125rem bg-white pr-1rem pl-1rem ml-1rem" v-if="region.isOsaka() && region.isSea()">
                                        <i class="material-icons font-size-1d5rem">{{ region.getTransportMaterialIcon() }}</i>
                                        해상
                                    </div>
                                </div>
                            </button>

                            <!-- 패킹버튼 -->
                            <button
                                class="uk-button uk-button-primary uk-button-large button-done"
                                type="button"
                                @click="packing"
                                v-show="totalAmountConfirmed && hasWeight"
                            >
                                <i class="material-icons">check</i>
                                패킹완료
                            </button>

                            <div style="flex-grow: 1"></div>


                            <!-- 취소버튼 -->
                            <button
                                class="uk-button uk-button-white"
                                type="button"
                                @click="cancel"
                            >
                                <i class="material-icons">close</i>
                                패킹작업 취소
                            </button>
                        </div>
                    </div>

                </div>


            </div>
        </div>

        <div v-if="packed && house" class="uk-grid-small" uk-grid>
            <div class="uk-width-1-2">
                <result
                    :house="house"
                    :packages="packages"
                    :pack-option-costs="packOptionCosts"
                    class="uk-margin-bottom"
                >
                </result>
            </div>

            <div class="uk-width-expand">
                <!-- 일반 패킹완료 -->
                <div
                    class="uk-card uk-card-default uk-margin-bottom"
                    v-if="! house.lock_shipout_hold"
                >
                    <div class="uk-card-header uk-text-large uk-text-center uk-text-primary">
                        <i class="material-icons">
                            done_outline
                        </i>
                        PACKING DONE
                    </div>
                    <div class="uk-card-body uk-text-large uk-text-center">
                        운송장을 출력하세요

                        <!-- 운송장 출력 -->
                        <div class="uk-text-center uk-margin-top">
                            <button
                                type="button"
                                class="uk-button uk-button-primary uk-button-large"
                                @click="clickPrintBl($event)"
                                :data-house-id="houseId"
                                title="운송장 라벨을 출력합니다"
                            >
                                <i class="material-icons">print</i>
                                PRINT LABEL (운송장)
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 출고보류건 -->
                <div
                    class="uk-card uk-card-default uk-margin-bottom"
                    v-if="house.lock_shipout_hold"
                >
                    <div class="uk-card-header uk-text-large uk-text-center uk-text-danger">
                        <i class="material-icons">
                            block
                        </i>
                        STOP
                    </div>
                    <div class="uk-card-body uk-text-large uk-text-center">
                        HOLDING BOX (출고보류) 입니다<br/>
                        절대 출고하지 마세요 !!
                    </div>
                    <div class="uk-card-footer uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-danger uk-button-large"
                            @click="clickHoldJob"
                        >
                            <i class="material-icons">build</i>
                            HOLDING (출고보류 작업)
                        </button>

                        <!-- 출고보류 컴포넌트 -->
                        <shipout-hold-job
                            ref="hold"
                            :csrf-token="csrfToken"
                        >
                        </shipout-hold-job>
                    </div>
                </div>

                <div class="uk-margin-bottom uk-text-center" v-show="isReadyToDone">
                    <!-- 완료처리 버튼 -->
                    <slot name="done-button"></slot>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
import regionAble from "../../common/region-able.vue";

export default {
    mixins: [
        regionAble,
    ],
    components: {
        'house': require('./house.vue').default,
        'prods': require('./prods.vue').default,
        'total-amount': require('./total-amount.vue').default,
        'pack-request': require('./pack-request.vue').default,
        'result': require('./result.vue').default,
        'shipout-hold-job': require('./shipout-hold-job.vue').default,
    },
    props: {
        // csrf-token
        csrfToken: String,

        /**
         * 로그인 유저 ID
         **/
        loginUserId: {
            type: Number,
            default: null,
        },

        /**
         * 사용단위 (기본값)
         * - kg : kg, cm 사용
         * - lb : lb(파운드), in(인치) 사용
         */
        defaultUnit: {
            type: String,
            default: 'kg',
        },


    },
    data: function () {
        return {
            // (int) 하우스ID
            houseId: null,

            // (object) 하우스정보
            house: null,

            // (Array) 상품정보
            prods: null,

            // (int) 총 수량
            totalAmount: null,

            // (object) 총 무게정보  {weight, volume_weight, apply_weight}
            totalWeight: {},

            // (bool) 총 수량 컨펌여부
            totalAmountConfirmed: false,

            // (bool) 패킹완료여부
            packed: false,

            // (Array) 패키지정보(결과)
            packages: null,

            // (Array) 포장옵션정보(결과)
            packOptionCosts: null,

            // (bool) 완료처리할 준비가 다 끝났는지 (운송장 출력버튼 눌렀는지..) 여부
            isReadyToDone: false,
        };
    },
    computed: {
        // 무게가 1개라도 입력되었는지 여부
        hasWeight() {
            return this.totalWeight.weight > 0;
        },

        /**
         * 지역
         * @return object
         */
        region() {
            if (! this.house) {
                return {};
            }
            return this.get_region(this.house.region_id);
        },

    },
    mounted: function () {

    },
    methods: {
        /**
         * 초기화
         */
        init(house_id) {
            this.houseId = house_id;
            this.house = null;
            this.prods = null;
            this.totalAmount = null;
            this.totalAmountConfirmed = true;
            this.packed = false;
            this.packages = null;
            this.packOptionCosts = null;
            this.isReadyToDone = false;

            this.load();
        },

        /**
         * ajax 패킹정보 조회
         */
        load() {
            // promise 생성
            let p = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/houses/' + this.houseId + '/pack-info',
                    data: {
                        //'_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            p.then((response) => {
                // 결과저장
                this.house = response.house;
                this.prods = response.prods;
                this.totalAmount = 0;
                _.each(this.prods, (prod) => {
                    this.totalAmount += prod.amount;
                });


                this.totalAmountConfirmed = this.totalAmount <= 1;


                // 테스트
                //this.packed = true; // todo 제거
            });
        },

        /**
         * 취소
         */
        cancel() {
            this.$emit('cancel');
        },

        /**
         * 패킹
         */
        packing() {
            // 포장옵션 정보
            var packing_options = this.$refs.options.getJson();

            // 패키지정보
            var validate = this.$refs.packages.isValidate();
            if (!validate.is_valid) {
                alert(validate.msg);
                return false;
            }
            let packages_json = this.$refs.packages.getPackagesJson();
            //console.log(packages_json);
            //return;

            // promise 생성
            let p = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/houses/' + this.houseId + '/packing',
                    data: {
                        '_token': this.csrfToken,
                        'packages_json': packages_json,
                        'packing_options': packing_options,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            p.then((response) => {
                this.packed = true;
                this.house = response.house;
                this.packages = response.packages;
                this.packOptionCosts = response.pack_option_costs;

                // 완료이벤트
                // this.$emit('done');

            });


        },

        /**
         * 운송장출력 버튼
         * @param event 이벤트객체
         */
        clickPrintBl(event) {
            $.app.print.bl([event]);
            this.isReadyToDone = true;
        },

        /**
         * 출고보류 버튼
         */
        clickHoldJob() {
            this.$refs.hold.form(this.houseId);
            this.isReadyToDone = true;
        },
    },


}
</script>

<style lang="scss" scoped>
.root {

}

.title {
    color: #000;

    .material-icons {
        font-size: 1.5rem;
    }

    &.title-left {
        width: 15rem;
        margin-right: 10px;
    }
}

.pack-request {
}

// 총수량
.total-amount-area {
    margin-top: -1px;
    padding: 5px;
    background-color: #fff;
    border: 1px solid #ccc;
    color: #000;

    strong {
        font-size: 2rem;
    }
}

// 고정영역 세로길이
.sticky-div-min-height {
    min-height: 22rem;
}

// 고정영역 가로길이
.sticky-div-width {
    width: 24rem;
}

.sticky-line {
    //background-color: blue;
    height: 0;

    position: sticky;
    bottom: 0;

    .sticky-relative {
        position: relative;

        .sticky-elem {
            position: absolute;
            bottom: 0;
            right: 0;
            background-color: #fff;
            border: 1px solid #999;
            padding: 1rem;

            height: 20rem;
            width: 20rem;

        }
    }

}


// 패킹버튼, 무게입력버튼
.button-done, .button-input-weight {
    margin-top: 1rem;
    height: 5rem;
    width: 100%;
}
</style>